import React, { type ReactNode } from 'react'

import { useSidebarState } from '@/hooks/useSidebarState'

import { SidebarContext } from './SidebarContext'

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const sidebarState = useSidebarState()

  return <SidebarContext.Provider value={sidebarState}>{children}</SidebarContext.Provider>
}
